import { defineMessages } from 'react-intl';

const enumMessages = defineMessages({
    spending_limit: {
        id: 'spending_limit',
        defaultMessage: 'Spending limit',
    },
    usage_limit: {
        id: 'usage_limit',
        defaultMessage: 'Usage limit',
    },
    restriction: {
        id: 'restriction',
        defaultMessage: 'Restriction',
    },
    card_selection: {
        id: 'card_selection',
        defaultMessage: 'Card selection',
    },
    basic_details: {
        id: 'basic_details',
        defaultMessage: 'Basic details',
    },
    reset_period: {
        id: 'reset_period',
        defaultMessage: 'Reset period',
    },
    conditions: {
        id: 'conditions',
        defaultMessage: 'Conditions',
    },
    daily: {
        id: 'daily',
        defaultMessage: 'Daily',
    },
    weekly: {
        id: 'weekly',
        defaultMessage: 'Weekly',
    },
    monthly: {
        id: 'monthly',
        defaultMessage: 'Monthly',
    },
    monday: {
        id: 'monday',
        defaultMessage: 'Monday',
    },
    tuesday: {
        id: 'tuesday',
        defaultMessage: 'Tuesday',
    },
    wednesday: {
        id: 'wednesday',
        defaultMessage: 'Wednesday',
    },
    thursday: {
        id: 'thursday',
        defaultMessage: 'Thursday',
    },
    friday: {
        id: 'friday',
        defaultMessage: 'Friday',
    },
    saturday: {
        id: 'saturday',
        defaultMessage: 'Saturday',
    },
    sunday: {
        id: 'sunday',
        defaultMessage: 'Sunday',
    },
    balance: {
        id: 'balance',
        defaultMessage: 'Balance',
    },
    amount: {
        id: 'amount',
        defaultMessage: 'Amount',
    },
    merchant_category_code: {
        id: 'merchant_category_code',
        defaultMessage: 'Merchant category code',
    },
    week_day: {
        id: 'week_day',
        defaultMessage: 'Week day',
    },
    month_day: {
        id: 'month_day',
        defaultMessage: 'Month day',
    },
    time_now: {
        id: 'time_now',
        defaultMessage: 'Time now',
    },
    entry_mode: {
        id: 'entry_mode',
        defaultMessage: 'Entry mode',
    },
    merchant_id: {
        id: 'merchant_id',
        defaultMessage: 'Merchant ID',
    },
    currency_code: {
        id: 'currency_code',
        defaultMessage: 'Currency code',
    },
    eq: {
        id: 'eq',
        defaultMessage: 'Equals',
    },
    neq: {
        id: 'neq',
        defaultMessage: 'Not equal',
    },
    lt: {
        id: 'lt',
        defaultMessage: 'Less than',
    },
    lte: {
        id: 'lte',
        defaultMessage: 'Less than or equal',
    },
    gt: {
        id: 'gt',
        defaultMessage: 'Greater than',
    },
    gte: {
        id: 'gte',
        defaultMessage: 'Greater than or equal',
    },
    in: {
        id: 'in',
        defaultMessage: 'In',
    },
    nin: {
        id: 'nin',
        defaultMessage: 'Not in',
    },
    resets: {
        id: 'resets',
        defaultMessage: 'Resets {day}',
    },
});

export default enumMessages;
